import {Directive, HostBinding, Injector, Input, OnInit, Optional} from '@angular/core';
import {takeUntil, tap} from 'rxjs/operators';
import {destroy$} from '../../../../components/destroyable';
import {Widget} from '../../../../components/layout/widget/widget';
import {LayoutSharedService, LayoutState} from '../layout-shared-service';
import {WidgetSettingsAction, WidgetSettingsComponent, WidgetSettingsComponentService} from '../widget/widget-settings';
import {CellComponent} from './cell.component';

const CONFIGURABLE_CLASS = '-configurable';

@Directive({
    selector: '[cell-widget-configurable]',
    standalone: false
})
export class CellWidgetConfigurableDirective implements OnInit {

    @Input()
    public widget: Widget;

    public readonly destroy$ = destroy$();

    @HostBinding(`class.${CONFIGURABLE_CLASS}`)
    public isConfigurable: boolean;

    protected settingsComponent: WidgetSettingsComponent;

    constructor(
        @Optional() // It's optional in case of Widget Page.
        private cellComponent: CellComponent,
        @Optional() // It's optional in case of Widget Page.
        private layoutSharedService: LayoutSharedService,
        private widgetSettingsComponentService: WidgetSettingsComponentService,
        private injector: Injector
    ) {}

    public ngOnInit(): void {
        this.listenToWidgetActions();

        this.isConfigurable = !!this.widget.widgetDescription.widgetSettingsComponentType;
    }

    protected openWidgetSettings(): void {
        if (!this.settingsComponent) {

            if (this.layoutSharedService) {
                this.layoutSharedService.blurOthers(this.widget.cell);
                this.layoutSharedService.setLayoutState(LayoutState.SETTINGS);
            }

            if (this.cellComponent) {
                this.cellComponent.settingsOpenedForWidget = this.widget;
            }

            this.settingsComponent = this.widgetSettingsComponentService.open({
                injector: this.injector,
                configure: {
                    widget: this.widget
                },
                onDestroy: () => this.closeWidgetSettings()
            });
        }
    }

    protected closeWidgetSettings(): void {
        if (this.settingsComponent) {
            this.widgetSettingsComponentService.close();

            if (this.cellComponent) {
                this.cellComponent.settingsOpenedForWidget = null;
            }

            if (this.layoutSharedService) {
                this.layoutSharedService.setLayoutState(LayoutState.NORMAL);
            }

            this.settingsComponent = null;
        }
    }

    private listenToWidgetActions(): void {
        const widgetActionsMap = {
            [WidgetSettingsAction.OPEN_WIDGET_SETTINGS]: () => this.openWidgetSettings()
        };

        this.widget.action$.pipe(
            takeUntil(this.destroy$),
            tap(action => {
                if (action.type in widgetActionsMap) {
                    (widgetActionsMap as any)[action.type](action);
                }
            })
        ).subscribe({
            complete: () => this.closeWidgetSettings()
        });
    }

}
